export default __webpack_public_path__ + "static/media/twitter_blue.889db2ca.png";